var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.21969 0.0150141 3.75 3.88922 3.75 8.20781C3.75 10.2881 4.52063 12.1847 5.79188 13.6359C6.56672 14.5191 7.77656 16.3655 8.23969 17.9227C8.24115 17.9344 8.24408 17.9469 8.24555 17.9593H15.7549C15.7564 17.9469 15.7593 17.9351 15.7608 17.9227C16.2237 16.3655 17.4338 14.5191 18.2086 13.6359C19.4813 12.225 20.25 10.3313 20.25 8.20781C20.25 3.69375 16.5563 0.000182813 12 0ZM16.5188 12.1922C15.7847 13.0289 14.8763 14.3625 14.2195 15.7495H9.78469C9.12797 14.3625 8.21953 13.0289 7.48594 12.1927C6.52688 11.1 6 9.66094 6 8.20781C6 5.31094 8.25469 2.26172 11.9578 2.25C15.3094 2.25 18 4.94063 18 8.20781C18 9.66094 17.475 11.1 16.5188 12.1922ZM11.25 3.75C9.18281 3.75 7.5 5.43281 7.5 7.5C7.5 7.91456 7.83544 8.25 8.25 8.25C8.66456 8.25 9 7.9125 9 7.5C9 6.25922 10.0092 5.25 11.25 5.25C11.6646 5.25 12 4.91494 12 4.50047C12 4.086 11.6625 3.75 11.25 3.75Z",
    fill: "#F28520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50238 22.1245C8.33981 21.8784 8.25469 21.5905 8.25469 21.2953L8.25 19.4578H15.75L15.744 21.2953C15.744 21.5452 15.631 21.917 15.4933 22.125L14.6927 23.3287C14.4466 23.6981 13.8878 23.9981 13.4453 23.9981H10.5546C10.1107 23.9981 9.55191 23.6979 9.30581 23.3287L8.50238 22.1245Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb2);
export default __webpack_public_path__ + "static/media/bulb-2.17cdc82293a00d8baee0dc3980fcbbd7.svg";
export { ForwardRef as ReactComponent };